import { render, staticRenderFns } from "./DowntimeSummaryOffcanvas.vue?vue&type=template&id=606be454&scoped=true&"
import script from "./DowntimeSummaryOffcanvas.vue?vue&type=script&lang=js&"
export * from "./DowntimeSummaryOffcanvas.vue?vue&type=script&lang=js&"
import style0 from "./DowntimeSummaryOffcanvas.vue?vue&type=style&index=0&id=606be454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606be454",
  null
  
)

export default component.exports